import { createContext, useContext, useCallback } from 'react';
import Raven from 'raven-js';
import enviro from 'enviro';
import { TRACKING_NAMESPACE } from '../constants/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackingContext = /*#__PURE__*/createContext(null);
export function TrackingProvider({
  tracker,
  children
}) {
  const track = useCallback((eventName, properties) => {
    tracker === null || tracker === void 0 || tracker.track(TRACKING_NAMESPACE, eventName, properties);
  }, [tracker]);
  return /*#__PURE__*/_jsx(TrackingContext.Provider, {
    value: {
      track,
      tracker
    },
    children: children
  });
}
export function useTracking() {
  const context = useContext(TrackingContext);
  if (!context) {
    const errorMessage = 'useTracking must be used within TrackingProvider';
    // Log this to the console in QA just so its evident, outside of Raven.
    if (enviro.isQa()) {
      console.error(errorMessage);
    }
    Raven.captureMessage(errorMessage);
    return {
      track: () => {},
      tracker: undefined
    };
  }
  return context;
}